import React, { useContext, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import DashboardContent from "../../components/dashboard";
import CuVoMetricsDashboardContent from "../../components/cuvo-metrics-dashboard";
import ReportsTicketsDashboardContent from "../../components/reports-tickets-dashboard";

import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { ROLE_USER_ADMIN, ROLE_USER_SUPERADMIN } from "../../model";
import SettingsFlag from "../../components/features";

import FeedbackMetric from "../../components/cuvo-metrics-dashboard/FeedbackMetric";
import FeedbackMetricTileCount from "../../components/cuvo-metrics-dashboard/FeedbackMetricTileCount";
import FeedbackMetricReputation from "../../components/cuvo-metrics-dashboard/FeedbackMetricReputation";

import { enableCorrelation } from "../../utils/config";
import { useLocation } from "react-router-dom";

interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
  className: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className={className}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Dashboard = () => {
  const messages: any = [];
  function a11yProps(index: number, label: any) {
    messages.push(label);
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const getLocation: any = useLocation();
  let defaultActiveTab = 0;

  if (
    getLocation &&
    getLocation.state &&
    getLocation.state.pageType == "mainReportPage"
  ) {
    defaultActiveTab = 1;
  }
  if (
    getLocation &&
    getLocation.state &&
    getLocation.state.pageType == "mainMetricsPage"
  ) {
    defaultActiveTab = 2;
  }
  window.onload = () => {
    setValue(0);
  };
  const [value, setValue] = React.useState(defaultActiveTab);

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const renderIndex = (label: any) => {
    const data = [...new Set(messages)];
    return data.indexOf(label);
  };
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  // console.log(JSON.parse(userEnabledFeatures), "userEnabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  return (
    <div className="feedback-wrap">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="dashboards">
          {/* {renderTabs()} */}
          {userEnabledFeatures &&
            (userEnabledFeatures.enableFeedback ||
              userEnabledFeatures.enableBugReport ||
              userEnabledFeatures.enableFeatureRequest) && (
              <Tab label="Performance" {...a11yProps(0, "Performance")} />
            )}
          {enableCorrelation && userEnabledFeatures?.enableCorrelation && (
            <Tab label="Correlation" {...a11yProps(1, "Correlation")} />
          )}
          <Tab label="Metrics" {...a11yProps(2, "Metrics")} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={renderIndex("Performance")} className="">
        <DashboardContent />
      </TabPanel>
      {/* {enableCorrelation && userEnabledFeatures?.enableCorrelation && ( */}
      <TabPanel value={value} index={renderIndex("Correlation")} className="">
        <ReportsTicketsDashboardContent />
      </TabPanel>
      {/* )} */}
      <TabPanel
        value={value}
        index={renderIndex("Metrics")}
        className="metrictab"
      >
        <CuVoMetricsDashboardContent />
      </TabPanel>
    </div>
  );
};

export default withSnackbar(Dashboard);
